import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

// Figma "icons / brand" book (Fertility-V 5725:5795).
export const Book = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.93315 3.86466C1.93315 3.60804 2.14118 3.4 2.39781 3.4H5.75912C6.47945 3.4 7.16852 3.69153 7.67522 4.20762C7.79658 4.33123 7.90512 4.46529 8 4.60769C8.09488 4.46529 8.20342 4.33123 8.32478 4.20762C8.83148 3.69153 9.52055 3.4 10.2409 3.4H13.6022C13.8588 3.4 14.0669 3.60804 14.0669 3.86466V12.4236C14.0669 12.6802 13.8588 12.8882 13.6022 12.8882H9.68066C9.36094 12.8882 9.05255 13.0175 8.82382 13.2505C8.5948 13.4837 8.46465 13.8019 8.46465 14.1353C8.46465 14.392 8.25662 14.6 7.99999 14.6C7.74337 14.6 7.53534 14.392 7.53534 14.1353C7.53534 13.8019 7.40519 13.4837 7.17618 13.2505C6.94745 13.0175 6.63906 12.8882 6.31934 12.8882H2.39781C2.14118 12.8882 1.93315 12.6802 1.93315 12.4236V3.86466ZM7.53534 12.3423C7.18069 12.0948 6.75741 11.9589 6.31934 11.9589H2.86246V4.32932H5.75912C6.22742 4.32932 6.6783 4.51872 7.01209 4.85869C7.34617 5.19895 7.53534 5.66222 7.53534 6.14703V12.3423ZM8.46465 12.3423C8.8193 12.0948 9.24259 11.9589 9.68066 11.9589H13.1375V4.32932H10.2409C9.77258 4.32932 9.3217 4.51872 8.98791 4.85869C8.65383 5.19895 8.46465 5.66223 8.46465 6.14703V12.3423Z"
    />
  </svg>
);
